// Small helpers shared by the floating chatbot

// The AI now returns a `preview` object, so replies are shown WITHOUT raw
// links / images (the preview card replaces them). Set to false to render
// clickable links + inline images again.
export const STRIP_LINKS_AND_IMAGES = true;

export const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// Only allow http(s) or same-site relative URLs
export const isSafeUrl = (u) => typeof u === "string" && (/^https?:\/\//i.test(u) || /^\/(?!\/)/.test(u));
export const safeUrl = (u) => (isSafeUrl(u) ? u : "#");

export function getMetaCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}

export function getFbc() {
  let fbc = getMetaCookie("_fbc");
  if (!fbc) {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid) {
      fbc = `fb.1.${Date.now()}.${fbclid}`;
      document.cookie = `_fbc=${fbc}; path=/; max-age=${90 * 24 * 60 * 60}`;
    }
  }
  return fbc;
}

export function trackPixelEvent(eventName, params, eventId) {
  if (typeof window === "undefined" || !window.fbq) {
    console.warn(`fbq not found — ${eventName} event not fired`);
    return;
  }
  if (eventId) window.fbq("track", eventName, params, { eventID: eventId });
  else window.fbq("track", eventName, params);
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Escapes first (safe for dangerouslySetInnerHTML), then applies light markdown.
export function formatContent(text) {
  if (!text) return "";

  let html = String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  if (STRIP_LINKS_AND_IMAGES) {
    html = html.replace(/!\[.*?\]\([^)]+\)/g, "");
    html = html.replace(/\[(.*?)\]\((?:https?:\/\/|\/)[^\s)]+\)/g, "<strong>$1</strong>");
  } else {
    html = html.replace(
      /!\[(.*?)\]\((https?:\/\/[^\s)"]+)\)/g,
      '<img src="$2" alt="$1" loading="lazy" class="my-2 rounded-xl w-full h-40 object-cover" />'
    );
    html = html.replace(
      /\[(.*?)\]\((https?:\/\/[^\s)"]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-indigo-600 underline break-all">$1</a>'
    );
  }

  const heading = '<strong class="block text-[15px] font-bold text-slate-900 mt-2 mb-1">$1</strong>';
  html = html.replace(/^### (.*$)/gim, heading);
  html = html.replace(/^## (.*$)/gim, heading);
  html = html.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  html = html.replace(/^\s*[-*]\s+(.*$)/gim, '<span class="text-indigo-500 font-bold mr-1">•</span> $1');
  html = html.replace(/\n/g, "<br/>");
  return html;
}

/**
 * True only when the payment redirect came from a payment started by the chatbot.
 * The chatbot's Razorpay callback_url must carry `src=chatbot`
 * (e.g. https://site/?bookingId=...&src=chatbot). Normal booking flows don't add it,
 * so their invoice pages never trigger the widget.
 */
export function isChatbotPaymentReturn(search = window.location.search) {
  const p = new URLSearchParams(search);
  return !!p.get("bookingId") && p.get("src") === "chatbot";
}